import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectBellNotificationData,
  setBellNotificationData,
} from "../../redux/slices/bellNotificationSlice";
import {
  getNotificationsAndNewOrder,
  readNotificathion,
} from "../../axios/api/OrderApi";
import { Audio } from "react-loader-spinner";

const NotificationDropdown = ({ setDropdownOpen, ignoreRef }) => {
  const dropdownRef = useRef(null);
  const bellNotificationData = useSelector(selectBellNotificationData);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (bellNotificationData) {
      setNotifications(bellNotificationData);
    }
  }, [bellNotificationData]);

  const markAsRead = async (id) => {
    try {
      setLoading(true);
      const responsedata = await readNotificathion(id);

      if (responsedata.data.status) {
        const data = await getNotificationsAndNewOrder();

        if (data?.data?.bellNotification) {
          dispatch(setBellNotificationData(data?.data?.bellNotification));
        }
      }
    } catch (error) {
      console.error("Error reading notification:", error);
    } finally {
      setLoading(false);
    }
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedOutsideDropdown =
        dropdownRef.current && !dropdownRef.current.contains(event.target);
      const clickedOutsideToggle =
        ignoreRef?.current && !ignoreRef.current.contains(event.target);

      if (clickedOutsideDropdown && clickedOutsideToggle) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setDropdownOpen, ignoreRef]);

  return (
    <div
      ref={dropdownRef}
      className="fixed inset-0 lg:inset-auto lg:absolute lg:w-[440px] bg-white lg:rounded-xl shadow-lg z-50 lg:z-10 py-6 border overflow-y-auto"
    >
      <div className="flex items-center justify-between px-6">
        <span className="prose-t20_bold text-primary flex gap-3">
          Ծանուցումներ
        </span>
        {/* Close Icon */}
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => setDropdownOpen(false)}
          className="cursor-pointer hover:opacity-80 transition-opacity duration-200"
        >
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="#64748B"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div className="mt-1 bg-a05 h-[1px]"></div>

      {/* 🔹 Loader while waiting */}
      {loading ? (
        <div className="flex items-center justify-center h-[50vh]">
          <Audio
            height="80"
            width="80"
            radius="9"
            color="#EE5222"
            ariaLabel="loading"
          />
        </div>
      ) : (
        <ul className="py-1 px-6 lg:max-h-[300px] overflow-y-auto">
          {notifications.length === 0 && (
            <li className="text-center py-4 text-gray-500">
              Ծանուցումներ չկան
            </li>
          )}
          {notifications.map((item) => (
            <li
              key={item.id}
              className={`flex justify-between items-center mt-3 border rounded-xl px-2 py-2 ${
                item.read ? "bg-white" : "bg-lightGray"
              }`}
            >
              <div className="flex flex-col gap-1.5 items-start text-start w-4/5">
                <span className="prose-t14_bold text-midnightBlue">
                  {item.name}
                </span>
                <span className="prose-t14_regular text-slateGray">
                  {item.massage}
                </span>
              </div>
              <div className="flex flex-col items-end gap-1">
                <span className="prose-t12_regular text-midnightBlue">
                  {item.date}
                </span>
                {!item.read && (
                  <button
                    onClick={() => markAsRead(item.id)}
                    className="text-xs text-blue-600 underline hover:text-blue-800"
                  >
                    Կարդալ
                  </button>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NotificationDropdown;
